var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.5,
    height: 25.75,
    viewBox: "0 0 26.5 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3, .cls-4 {\n        fill: #7d7d7d;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #7d7d7d;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11293",
    "data-name": "Group 11293",
    transform: "translate(-480.75 -4126.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    className: "cls-1",
    d: "M0,163.2H7.346",
    transform: "translate(481.5 3987.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    className: "cls-2",
    d: "M62.327,49.292,72.673,40.3",
    transform: "translate(426.519 4101.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8049",
    "data-name": "Path 8049",
    className: "cls-3",
    d: "M0,1V23.7",
    transform: "translate(502.863 4126.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    className: "cls-3",
    d: "M3.916,0H.385",
    transform: "translate(502.471 4127.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8059",
    "data-name": "Path 8059",
    className: "cls-3",
    d: "M12.524,0H-1",
    transform: "translate(488.227 4141.337)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2206",
    "data-name": "Ellipse 2206",
    className: "cls-4",
    cx: 1.942,
    cy: 1.95,
    rx: 1.942,
    ry: 1.95,
    transform: "translate(491.916 4148.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8044",
    "data-name": "Path 8044",
    className: "cls-3",
    d: "M3.916,0H.385",
    transform: "translate(502.471 4132.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8045",
    "data-name": "Path 8045",
    className: "cls-3",
    d: "M3.916,0H.385",
    transform: "translate(502.471 4136.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8046",
    "data-name": "Path 8046",
    className: "cls-3",
    d: "M3.916,0H.385",
    transform: "translate(502.471 4141.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8047",
    "data-name": "Path 8047",
    className: "cls-3",
    d: "M3.916,0H.385",
    transform: "translate(502.471 4145.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8050",
    "data-name": "Path 8050",
    className: "cls-3",
    d: "M0,1V23.7",
    transform: "translate(485.164 4126.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8052",
    "data-name": "Path 8052",
    className: "cls-3",
    d: "M.385,0H3.916",
    transform: "translate(481.254 4127.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8053",
    "data-name": "Path 8053",
    className: "cls-3",
    d: "M.385,0H3.916",
    transform: "translate(481.254 4132.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8054",
    "data-name": "Path 8054",
    className: "cls-3",
    d: "M.385,0H3.916",
    transform: "translate(481.254 4136.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8055",
    "data-name": "Path 8055",
    className: "cls-3",
    d: "M.385,0H3.916",
    transform: "translate(481.254 4141.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8056",
    "data-name": "Path 8056",
    className: "cls-3",
    d: "M.385,0H3.916",
    transform: "translate(481.254 4145.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8057",
    "data-name": "Path 8057",
    className: "cls-2",
    d: "M72.673,49.292,62.327,40.3",
    transform: "translate(426.519 4101.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8058",
    "data-name": "Path 8058",
    className: "cls-1",
    d: "M0,163.2H7.346",
    transform: "translate(499.154 3987.175)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLift);
export default __webpack_public_path__ + "static/media/lift.b8f3da6585885a20489e5d020e53d5d5.svg";
export { ForwardRef as ReactComponent };